import { useEffect, useRef, useState } from "react";

// Smooth count-up with ease-out cubic. Re-runs when `value` changes.
export default function CountUp({ value = 0, duration = 1100, className = "" }) {
  const [n, setN] = useState(0);
  const raf = useRef();
  useEffect(() => {
    const to = Number(value) || 0;
    const start = performance.now();
    cancelAnimationFrame(raf.current);
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(to * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);
  return <span className={className}>{n.toLocaleString("pt-BR")}</span>;
}
